export const statusColor = {
  scheduled: "indigo",
  confirmed: "cyan",
  attendance: "yellow",
  canceled: "brown",
  missed: "red",
  finished: "green",
};
